import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <main className="contact">
      <section className="contact-section">
        <div className="container">
          <h1>Contact</h1>
          <p className="contact-lead">
            사이버보안 직무 관련 협업, 채용 제안, 인터뷰를 환영합니다. GitHub와
            Velog를 통해 프로젝트와 보안 관련 기술 경험을 함께 확인하실 수
            있습니다.
          </p>
          <div className="contact-grid">
            <article className="contact-card">
              <h2>이메일</h2>
              <p>seohoon0707@gmail.com</p>
              <a href="mailto:seohoon0707@gmail.com">메일 보내기</a>
            </article>
            <article className="contact-card">
              <h2>전화</h2>
              <p>010-4124-1348</p>
              <a href="tel:01041241348">전화 걸기</a>
            </article>
            <article className="contact-card">
              <h2>GitHub</h2>
              <p>@Simseoh</p>
              <a
                href="https://github.com/Simseoh"
                target="_blank"
                rel="noopener noreferrer"
              >
                프로필 방문
              </a>
            </article>
            <article className="contact-card">
              <h2>Homepage</h2>
              <p>www.seohoon.kro.kr</p>
              <a
                href="http://www.seohoon.kro.kr"
                target="_blank"
                rel="noopener noreferrer"
              >
                사이트 방문
              </a>
            </article>
            <article className="contact-card">
              <h2>Velog</h2>
              <p>@s_s877</p>
              <a
                href="https://velog.io/@s_s877h/posts"
                target="_blank"
                rel="noreferrer"
              >
                기술 글 보기
              </a>
            </article>
            <article className="contact-card">
              <h2>한 줄 소개</h2>
              <p>
                서비스 이해를 기반으로 개발과 보안을 하나의 흐름으로 통합하여
                안정적이고 신뢰할 수 있는 시스템을 만듭니다.
              </p>
            </article>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Contact;
